var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9999 0C7.9169 0 7.8329 0.045 7.7949 0.137L5.6899 5.22L0.203897 5.652C0.0078975 5.667 -0.0721025 5.913 0.0778975 6.042L4.2619 9.615L2.9769 14.965C2.9409 15.114 3.0599 15.239 3.1929 15.239C3.2309 15.239 3.2709 15.229 3.3089 15.206L7.9999 12.331L12.6909 15.206C12.7289 15.229 12.7679 15.239 12.8069 15.239C12.9399 15.239 13.0579 15.114 13.0219 14.965L11.7379 9.615L15.9219 6.042C16.0719 5.913 15.9919 5.667 15.7949 5.652L10.3099 5.22L8.2049 0.137C8.1669 0.045 8.0829 0 7.9999 0ZM7.99987 2.77901L9.20087 5.67901L9.48287 6.35901L10.2159 6.41701L13.3459 6.66301L10.9589 8.70201L10.3989 9.18001L10.5709 9.89501L11.3039 12.948L8.62687 11.307L7.99987 10.923L7.37287 11.307L4.69587 12.948L5.42887 9.89501L5.60087 9.18001L5.04087 8.70201L2.65387 6.66301L5.78387 6.41701L6.51687 6.35901L6.79787 5.67901L7.99987 2.77901Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.e50d998b.svg";
export { ForwardRef as ReactComponent };